import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { MaterialModule } from "src/app/app.materials";

@Component({
  selector: "app-benchmark-category-panel",
  templateUrl: "./benchmark-category-panel.component.html",
  styleUrls: ["./benchmark-category-panel.component.scss"],
  standalone: true,
  imports: [MaterialModule],
  encapsulation: ViewEncapsulation.None
})
export class BenchmarkCategoryPanelComponent {
  @Input() title = "";
  @Input() items: any[] = [];
  @Input() selectedBenchmark: any;
  @Output() benchmarkSelect = new EventEmitter<any>();

  onSelect(item: any) {
    this.benchmarkSelect.emit(item);
  }
}
